<script lang="ts" setup>

  type Props = {
    disabled?: boolean
    readonly?: boolean
    label: string
    name: string
    errors?: string[]
    required?: boolean
  }

  const props = defineProps<Props>()

  const model = defineModel<boolean>({ required: true })

  function input(e: Event): void {
    model.value = (e.target as HTMLInputElement).checked
  }
</script>
<template>
  <div class="c-checkbox">
    <label
      v-show="props.label"
      :for="name"
    >
      <input
        :id="name"
        type="checkbox"
        :disabled="props.disabled"
        :readonly="props.readonly"
        :name="props.name"
        :value="model"
        :required="props.required"
        @input="input"
      >
      <SvgIcon
        icon="check"
        :width="12"
        :height="12"
      />
      <span class="label-txt" v-html="props.label" />
    </label>
    <span
      v-show="props.errors && props.errors.length > 0"
      class="error"
    >
      {{ props.errors?.[0] }}
    </span>
  </div>
</template>
<style scoped>
.c-checkbox {
  label {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;

    input {
      position: absolute;
      width: 1rem;
      height: 1rem;
      margin: 0;
      opacity: 0;

      &:checked {
        ~ .c-icon {
          color: var(--color-primary);
        }
      }

      &:disabled {
        ~ .c-icon {
          opacity: 0.5;
        }
      }

      &:checked:disabled {
        ~ .c-icon {
          color: var(--color-secondary);
        }
      }
    }

    .c-icon {
      width: 1em;
      height: 1em;
      border: solid 1px var(--color-secondary);
      border-radius: 2px;
      margin-right: 0.75em;
      color: transparent;
      cursor: pointer;
      transition: color ease-out 0.15s, background-color ease-out 0.15s;

      &:hover {
        background-color: var(--color-secondary-light);
      }
    }

    .label-txt {
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 0.875em;
      font-weight: inherit;
    }
  }

  .error {
    display: flex;
    margin-top: 0.25rem;
    color: var(--color-error);
    font-family: Open-Sans, sans-serif;
    font-size: 0.75em;
    font-weight: normal;
  }
}
</style>
